import { Navigate, useParams } from 'react-router-dom';
import { Button, Card } from 'antd';
import { useOnboarding } from '../../context/OnboardingContext';
import { buildBotPath } from '../../utils/routes';

const OnboardingEntry = () => {
    const { bot_id } = useParams();
    const { isInitializing, initialError, subscriptionStatus } = useOnboarding();

    if (isInitializing) {
        return null;
    }

    if (initialError) {
        return (
            <div className="onboarding-shell">
                <Card className="onboarding-card" bordered={false}>
                    <p className="section-text" style={{ marginBottom: 16 }}>
                        {initialError}
                    </p>
                    <div className="error-action">
                        <Button type="primary" block onClick={() => window.location.reload()}>
                            Qayta urinib ko'rish
                        </Button>
                    </div>
                </Card>
            </div>
        );
    }

    // Checked before `is_active`, so a blocked user never reaches the tariff list. A `pending` block
    // still has a paid period running, so it keeps going to the dashboard.
    if (subscriptionStatus?.block?.state === 'active') {
        return <Navigate to={buildBotPath(bot_id, '/onboarding/blocked')} replace />;
    }

    if (subscriptionStatus?.is_active) {
        return <Navigate to={buildBotPath(bot_id, '/onboarding/dashboard')} replace />;
    }

    return <Navigate to={buildBotPath(bot_id, '/onboarding/tariff')} replace />;
};

export default OnboardingEntry;
